/**
 * `/$org/apps/imanage/favorites`: see IManageFavoritesPage.
 *
 * @module routes/$org.apps.imanage.favorites
 */
import { createFileRoute } from "@tanstack/react-router";

import { IManageFavoritesPage } from "../components/apps/imanage/IManagePages";
import { parseIManageSearch } from "../components/apps/imanage/imanagePaths";

function IManageFavoritesRoute() {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <IManageFavoritesPage
      search={search}
      onSearchChange={(next, options) => void navigate({ search: next, replace: options?.replace ?? false })}
    />
  );
}

export const Route = createFileRoute("/$org/apps/imanage/favorites")({
  validateSearch: parseIManageSearch,
  component: IManageFavoritesRoute,
});
